import axios from 'axios';

export const getUserInfo = () => {
    return axios.get('/api/loggedInUser');
};

export const logOut = () => {
    return axios.get('/logout');
};
